<template>
    <div class="vue-country-filter-button">
        <a href="#" @click.prevent="handleFilterClicked" :class="{'active': active}">
            <span class="icon" v-if="hasIcon" :style="`mask-image: url('${item.icon}');`"></span>

            {{ item.name }}
        </a>
    </div>
</template>

<script>
export default {
    name: "CountryFilterButton",

    props: ['item', 'activeFilters', 'eventBus'],

    data() {
        return {
            active: false
        }
    },

    computed: {
        hasIcon() {
            return ! _.isEmpty(this.item.icon);
        }
    },

    mounted() {
       this.eventBus.$on('reset-filters', () => this.active = false);
    },

    methods: {
        handleFilterClicked() {
            this.active = ! this.active;

            if (this.active) {
                this.$emit('selected', this.item);
                return;
            }

            this.$emit('deselected', this.item);
        }
    }
}
</script>